'use strict';

/*

    ConnectionError

    ConnectionError is a mogo-page component for the member portal that displays an error
    informing the user that there is a connection problem. The component has two different
    states: a countdown state and a retry state. The countdown state includes a timer
    that can be started/stopped to update the UI with a countdown to the next attempt to
    reconnect. A callback is invoked every 10 seconds on the timer. The retry state
    provides CTAs for the user to try again or be redirected to the dashboard.

    Arguments:
        retryCallback (optional) [function]:
            The callback function to execute every 10 seconds when the timer is running.

        allowTryAgain (optional) [boolean]:
            Defaults to true. Specifies whether the user can re-try the connection request
            and the 'Try Again' button is displayed.

        destroyCallback (optional) [function]:
            Callback to be executed on destruction of this object.

    Methods:
        cancelTimer()
            Cancels the timer and stops the periodic invocation of retryCallback.
*/
function ConnectionError() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  this.extends = [_Routes];
  this._initialized = false;
  this._secondsTimer = null;
  this._RETRY_SECONDS = 30;
  this._currentSeconds = -1;
  this._state = 'initial';

  this.retryCallback = null;
  this.finalFailCallback = null;
  this.destroyCallback = null;
  this.allowTryAgain = true;
  this.isEntirePage = true;
  this.hidePage = null;
  this.analytics = new Analytics();
  this.analyticsData = null;

  this._classes = {
    class: 'connection-error',
    mod_show: 'connection-error--show',
    mod_fullscreen: 'connection-error--full-screen'
  };

  this.init = function () {
    // Parameter check
    if (typeof this.retryCallback !== 'function') this.retryCallback = null;
    if (typeof this.finalFailCallback !== 'function') this.finalFailCallback = null;

    if (!this.allowTryAgain) {
      $('.connection-error__button--again', this.node).addClass('disabled');
    }

    this._initialized = true;
  };

  this.initAllReady = function () {
    $(this.node).addClass(this._classes.mod_show).toggleClass(this._classes.mod_fullscreen, this.isEntirePage);

    if (!this._initialized) return;

    // Add connections
    if (this.tryAgainCallback) {
      $('.connection-error__button--again', this.node).on('click', { ConnectionErrorInstance: this, onTryAgain: this._onTryAgain }, this.tryAgainCallback);
    }
    $('.connection-error__button--again', this.node).on('click', $.proxy(this._onTryAgain, this));

    $('.connection-error__button--dashboard', this.node).on('click', $.proxy(this._onGoToDashboard, this));
    $(document).on('visibilitychange.connectionerror', $.proxy(this._onVisibilityChange, this));

    if (!this.tryAgainCallback) {
      this._startTimer();
    }
  };

  /*
        Description:
            Cancels the time and stops invocation of retryCallback.
    */
  this.cancelTimer = function () {
    clearTimeout(this._secondsTimer);
    this._secondsTimer = null;
  };

  this.showInitialState = function () {
    this._state = 'initial';
    $('.connection-error__buttons', this.node).fadeOut(350, $.proxy(function () {
      $('.connection-error__try-again-message', this.node).fadeIn(350);
      $('.connection-error__overtime-message', this.node).hide();
      $('.connection-error__final-message', this.node).hide();
      $('.connection-error__initial-message', this.node).show();
    }, this));
  };

  this.showOvertimeState = function () {
    this._state = 'overtime';
    this._show();
    if (!this.isEntirePage) {
      $('.connection-error__initial-message', this.node).hide();
      $('.connection-error__final-message', this.node).hide();
    }
    $('.connection-error__try-again-message', this.node).hide();
    $('.connection-error__overtime-message', this.node).show();
  };

  this.showFinalState = function () {
    this._state = 'final';
    this._show();
    clearTimeout(this._secondsTimer);
    this._secondsTimer = null;
    this.analytics.pushEvent('connection-issue-try-again', this.analyticsData);

    $('.connection-error__overtime-message', this.node).hide();
    $('.connection-error__initial-message', this.node).hide();
    $('.connection-error__final-message', this.node).show();
    $('.connection-error__try-again-message', this.node).fadeOut(250, $.proxy(function () {
      $('.connection-error__buttons', this.node).fadeIn(350);
    }, this));
    if (this.finalFailCallback) this.finalFailCallback();
  };

  this._onTryAgain = function (e) {
    e.preventDefault();
    $('.connection-error__time-seconds', this.node).html(this._RETRY_SECONDS);
    this.showInitialState();
    this._startTimer();
  };

  this._onGoToDashboard = function (e) {
    e.preventDefault();
    var h = new History();
    h.goToUrl('/member/dashboard/home');
  };

  this._startTimer = function () {
    if (this._secondsTimer != null) return;

    this._currentSeconds = 30;
    this._secondsTimer = setInterval($.proxy(this._decrementTimer, this), 1000);
  };

  this._decrementTimer = function () {
    this.retryCallback(this._currentSeconds);
    if (this._currentSeconds > 0) {
      $('.connection-error__time-seconds', this.node).html(this._currentSeconds);
      this._currentSeconds--;
    }
  };

  this._show = function () {
    $(this.node).show();
    this.hidePage();
  };

  this._onVisibilityChange = function () {
    if (this._state == 'initial') {
      $('.connection-error__buttons', this.node).hide();
      $('.connection-error__overtime-message', this.node).hide();
      $('.connection-error__final-message', this.node).hide();
      $('.connection-error__try-again-message', this.node).show();
      $('.connection-error__initial-message', this.node).show();
    } else if (this._state == 'overtime') {
      $('.connection-error__overtime-message', this.node).show();
      $('.connection-error__initial-message', this.node).show();
      $('.connection-error__try-again-message', this.node).hide();
      $('.connection-error__buttons', this.node).hide();
      $('.connection-error__final-message', this.node).hide();
    } else if (this._state == 'final') {
      $('.connection-error__overtime-message', this.node).hide();
      $('.connection-error__try-again-message', this.node).hide();
      $('.connection-error__initial-message', this.node).hide();
      $('.connection-error__buttons', this.node).show();
      $('.connection-error__final-message', this.node).show();
    }
  };

  this.destroy = function () {
    $(document).off('visibilitychange.connectionerror');
    if (this._secondsTimer) {
      clearTimeout(this._secondsTimer);
    }
    if (typeof this.destroyCallback === 'function') {
      this.destroyCallback();
    }
  };
}